import { render } from "./AdrAbout.vue?vue&type=template&id=841fbba0"
import script from "./AdrAbout.vue?vue&type=script&lang=js"
export * from "./AdrAbout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__